module.exports = __webpack_public_path__ + "static/media/Three-Icon.6e37a856.svg";